import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useGamesPortal } from "../hooks/use-games-portal";
import { GamesDockPanel } from "./GamesDockPanel";

export const GamesPortalRoot = () => {
  const { t } = useTranslation();
  const { isOpen, isFullscreen, closePortal } = useGamesPortal();

  if (!isOpen || typeof document === "undefined") {
    return null;
  }

  const portalContent = (
    <div className="fixed inset-0 z-[10000] pointer-events-none">
      {isFullscreen && (
        <button
          type="button"
          aria-label={t("games.close")}
          className="absolute inset-0 bg-[var(--colors-background-bg-overlay)] pointer-events-auto"
          onClick={closePortal}
        />
      )}
      <GamesDockPanel />
    </div>
  );

  return createPortal(portalContent, document.body);
};
